// extracted by mini-css-extract-plugin
export var chevron = "_a2-2";
export var dropdownItems = "_a2-0";
export var item = "_a2-1";